
const labelStyles = {
  display: 'inline-block',
  width: '25%',
  paddingRight: '8px',
}

export default {
  name: {
    type: 'text',
    label: 'Name',
    required: true,
    labelStyles,
  },
  email: {
    type: 'email',
    label: 'Email Address',
    labelStyles,
  },
  phone: {
    type: 'phone',
    label: 'Phone Number',
    labelStyles,
  },
  emailNotifications: {
    type: 'radio',
    label: 'Receive email Notifications? ',
    options: [['Yes', 'true'], ['No', 'false']],
    required: true,
    labelStyles,
  },
}
